import { useEffect } from 'react';
import { useRouter } from 'next/router';

import {
  Card,
  CardBody,
} from 'reactstrap';

import WithState from '@/engine/decorators/with-state';
import WithActions from '@/engine/decorators/with-actions';

import Button from '@/components/button';
import Loading from '@/components/loading';

import EditPropertyForm from './edit-property-form';

const renderLoading = () => {
  return (
    <Loading />
  );
};

const renderEdit = (property) => {
  return (
    <>
      <h1 className="swatch-title swatch-title--main swatch-title--main swatch-title--main-small">
        <small>Edit</small>
        Reno Details
      </h1>
      <Card className="mw-30 m-auto card-raised">
        <CardBody>
          <EditPropertyForm
            property={property}
            isEditingExisting
          />
        </CardBody>
      </Card>
    </>
  );
};

const EditProperty = ({ publish, property }) => {
  const router = useRouter();
  const { id } = router.query;

  useEffect(() => {
    if (id) {
      publish({ event: 'load', id });
    }
  }, [id]);

  if (!id) {
    return null;
  }

  return (
    <div className="property">
      <div className="back-button-top-container">
        <Button
          id="property-edit-back"
          actionMetaData={{ propertyId: id }}
          swatch
          color="secondary"
          className="back-button-top"
          size="sm"
        >
          Back
        </Button>
      </div>
      {property?.id ? renderEdit(property) : renderLoading()}
    </div>
  );
};

export default WithActions(WithState(EditProperty));
